import React from 'react';
import CheckCircleIcon from 'mdi-react/CheckCircleIcon';
import CloseCircleIcon from 'mdi-react/CloseCircleIcon';

import { IconButton } from '@crm-framework/icon-button';

export const renderStatusColumn = (value: undefined | boolean) => {
  if (value == null) {
    return null;
  }

  return (
    <IconButton
      size="sm"
      icon={value ? CheckCircleIcon : CloseCircleIcon}
      appearance={value ? 'success' : 'danger'}
    />
  );
};
